import styled from 'styled-components'

const BlockHeaderActions = styled.div`
	display: flex;
	flex-direction: row;
`

export default BlockHeaderActions